<template>
    <s-basic-slice class="s-tabs" v-bind="l10n">
        <a-tabs
            :type="type"
            :type-width="typeWidth"
            :no-top-spacing="noTopSpacing"
            :no-bottom-spacing="noBottomSpacing"
            :use-small-tabs="useSmallTabs"
        >
            <a-tab
                v-for="(slice, index) in l10n.slices"
                :key="index"
                :label="slice.label"
                :anchor-id="slice.anchorId"
            >
                <component
                    :is="dynamicComponents[slice.name]"
                    class="s-tabs__item"
                    v-bind="slice.data"
                />
            </a-tab>
        </a-tabs>
    </s-basic-slice>
</template>

<script lang="ts">
import { defineComponent, defineAsyncComponent, shallowReactive, getCurrentInstance, onBeforeMount } from 'vue';
import ATab from '@core/components/tabs/tab.vue';
import ATabs from '@core/components/tabs/tabs.vue';
import l10n from '@core/mixins/l10n.js';
import SBasicSlice from '@core/slices/pages/basic-slice/basic-slice.vue';

export default defineComponent({
    name: 'STabs',

    components: {
        ATab,
        ATabs,
        SBasicSlice,
    },

    mixins: [l10n],

    inheritAttrs: false,

    props: {
        slices: {
            type: Array,
            default: () => [],
        },
        noTopSpacing: {
            type: Boolean,
            default: false,
        },
        noBottomSpacing: {
            type: Boolean,
            default: false,
        },
        useSmallTabs: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: undefined,
        },
        typeWidth: {
            type: String,
            default: undefined,
        },
    },

    setup() {
        const dynamicComponents = shallowReactive<Record<string, any>>({});

        onBeforeMount(() => {
            // TODO: getCurrentInstance can be replaced utilizing Composition API
            const instance = getCurrentInstance();
            const slices = instance?.proxy?.l10n?.slices ?? [];

            const uniqueNames = new Set(slices.map((slice: any) => slice.name));

            uniqueNames.forEach((systemName) => {
                if (!dynamicComponents[systemName]) {
                    let diskName = systemName.startsWith('s-') ? systemName.slice(2) : systemName;
                    dynamicComponents[systemName] = defineAsyncComponent(() =>
                        import(`@core/slices/pages/${diskName}/${diskName}.vue`),
                    );
                }
            });
        });

        return {
            dynamicComponents,
        };
    },
});
</script>

<style lang="postcss" scoped>
.s-tabs {
    :deep(.a-container .a-container) {
        padding: 0;
    }

    &__item {
        padding: 0;
    }
}
</style>
